import { ReactNode, useEffect, useRef, useState } from 'react';
import { buildCurrentDevice, DeviceContext, DeviceContextType } from 'context/DeviceContext';

export function DeviceProvider({ children }: { children: ReactNode }) {
  const waitRef = useRef(null as ReturnType<typeof setTimeout> | null);
  const [context, setContext] = useState<DeviceContextType>(buildCurrentDevice());

  useEffect(() => {
    function handleResize() {
      if (waitRef.current) {
        clearTimeout(waitRef.current);
      }

      waitRef.current = setTimeout(() => {
        setContext(buildCurrentDevice());
      }, 500);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return <DeviceContext.Provider value={context}>{children}</DeviceContext.Provider>;
}
